import { PageGroup } from '@sleepstation/components'
import { FormWrapper } from '@sleepstation/components-form'
import { WrittenTestimonialForm } from '@sleepstation/components-forms-public-app'
import { VLayout } from '@sleepstation/components-layouts'
import mapping from '@sleepstation/components-markdown-copy-mapping'
import { MarkdownRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { marginTop } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import { always, dissoc, when } from 'ramda'
import React from 'react'
import styled from 'styled-components'
import { useSearchParams } from 'react-router-dom'
import QUERY_PARAMS from '../../../../const/queryParams'
import FooterNav from '../../../shared/FooterNav'
import ListCard from '../../../shared/ListCard'
import BreakoutModuleNarrow from '../../../shared/breakoutModules/BreakoutModuleNarrow'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const FORM_MODAL_ERROR_MESSAGE = `Something went wrong. Please try again later`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.LARGE,
  'data-cy': `feedback-written-testimonial-page-content`,
})``

const Footer = styled(VLayout).attrs({ align: LAYOUT_ALIGN.CENTER })`
  ${marginTop(2)}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FeedbackWrittenTestimonialPage = ({
  content,
  createFeedback,
  onSuccess,
}) => {
  const [searchParams] = useSearchParams()
  const showSecondaryNav =
    searchParams.get(QUERY_PARAMS.SHOW_SECONDARY_NAV) === `1`

  const footerNav = when(
    always(!showSecondaryNav),
    dissoc(`secondary`),
    content.footerNav
  )

  return (
    <BreakoutModuleNarrow
      hasGradient={false}
      hasBottomBorder={false}
      paddingV={[[1], [2, 1], [2.25, 1]]}
    >
      <Layout>
        <PageGroup title={content.title} isClose>
          <MarkdownRenderer htmlAst={content.bodyAst} mapping={mapping} />
          <ListCard {...content.ideasCard} />
        </PageGroup>
        <FormWrapper
          wrappedComponent={WrittenTestimonialForm}
          promise={createFeedback}
          onSuccess={onSuccess}
          modalBody={FORM_MODAL_ERROR_MESSAGE}
        />
        <Footer>
          <FooterNav nav={footerNav} />
        </Footer>
      </Layout>
    </BreakoutModuleNarrow>
  )
}

FeedbackWrittenTestimonialPage.propTypes = {
  content: PropTypes.object.isRequired,
  createFeedback: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}

export default FeedbackWrittenTestimonialPage
